<app-page-meta pageTitle="finzy - Apply for a loan with finzy"
               tags="finzy, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, quick personal loans, low interest personal loans"
               description="finzy is the premier peer to peer lending solution in India. We connect borrowers with investors and make loans simple and easy. With low interest rates, a hassle free loan application process, no prepayment charges, no lock-in periods, finzy is the best place to apply for a personal loan.">
</app-page-meta>

<div class="row mainrow">
  <p class="heading">Here are a few things you will need to get started:</p>
  <ul class="ulclass">
    <li class="liclass">Your phone for the OTP</li>
    <li class="liclass">PAN Card</li>
    <li class="liclass">Recent passport sized photograph</li>
    <li class="liclass">IT Return/Form 16 for last year</li>
    <li class="liclass">Bank statements for the last 6 months</li>
    <li class="liclass">Salary Slips for the last 3 months</li>
    <li class="liclass">Masked e-Aadhaar or any proof of current address
      <app-tooltip selectorForTrigger=".infoIcon">
        <i class="infoIcon material-icons" trigger>info_outline</i>
        <div content>
          <div style="width: 88vw;max-width: 460px;">
            <p>You can choose to submit any below address proof. Please remember that the execution of documents
              will be
              done at the address as on the proof you submit.
            </p>
            <div class="flex-container hidden-sm hidden-xs">
              <div>
                <ul class="document-info-ul-class">
                  <li class="document-info-li-class"> Driving Licence</li>
                  <li class="document-info-li-class">Voter ID Card</li>
                  <li class="document-info-li-class">Passport</li>
                </ul>
              </div>
              <div>
                <ul class="document-info-ul-class">
                  <li class="document-info-li-class"> LPG Bill (most recent)</li>
                  <li class="document-info-li-class">MTNL/BSNL Landline Bill (most recent)</li>
                  <li class="document-info-li-class"> Electricity Bill (most recent)</li>
                </ul>
              </div>
            </div>
            <div class="flex-container hidden-md hidden-lg">
              <div>
                <ul class="document-info-ul-class">
                  <li class="document-info-li-class"> Driving Licence</li>
                  <li class="document-info-li-class">Voter ID Card</li>
                  <li class="document-info-li-class">Passport</li>
                  <li class="document-info-li-class"> LPG Bill (most recent)</li>
                  <li class="document-info-li-class">MTNL/BSNL Landline Bill (most recent)</li>
                  <li class="document-info-li-class"> Electricity Bill (most recent)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </app-tooltip>
    </li>
  </ul>

  <app-referral-input [isDisabled]="isUserRegistered" *ngIf="referralFeatureEnabled"></app-referral-input>

  <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading"
                      (click)="verifyAndProceed(); analyticsTracker.trackButtonClick('Borrower referral page', 'Get Started' , 'Borrower Flow Finzy Domain')">
    GET STARTED
  </app-forward-button>
</div>
